
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"uberadmin"},{"kind":"EnumValue","value":"siteAdmin"},{"kind":"EnumValue","value":"instructor"},{"kind":"EnumValue","value":"learner"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"planning"},"name":{"kind":"Name","value":"assignmentProgressList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"assignmentHandle"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"mealPlanning","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"completed","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"boolean"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deployment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deploymentId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meal_planning_date"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tracking"},"name":{"kind":"Name","value":"assignmentProgressList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"assignmentHandle"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"mealTracking","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"completed","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"boolean"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deployment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deploymentId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meal_tracking_date"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"uberadmin"},{"kind":"EnumValue","value":"siteAdmin"},{"kind":"EnumValue","value":"instructor"},{"kind":"EnumValue","value":"learner"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatedDate"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1009}};
    doc.loc.source = {"body":"query($pawnId: Int) {\n    flows(as: [uberadmin, siteAdmin, instructor, learner]) {\n        planning: assignmentProgressList(\n            pawnId: [$pawnId]\n            assignmentHandle: [\"mealPlanning\"]\n            filter: { eq: { field: \"completed\", boolean: true } }\n        ) {\n            completedAt\n            deployment {\n                deploymentId\n            }\n            devTags {\n                meal_planning_date\n            }\n        }\n        tracking: assignmentProgressList(\n            pawnId: [$pawnId]\n            assignmentHandle: [\"mealTracking\"]\n            filter: { eq: { field: \"completed\", boolean: true } }\n        ) {\n            completedAt\n            deployment {\n                deploymentId\n            }\n            devTags {\n                meal_tracking_date\n            }\n        }\n    }\n\n    roles(as: [uberadmin, siteAdmin, instructor, learner]) {\n        learner(pawnId: [$pawnId]) {\n            user {\n                activatedDate\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
